/**
 * GraphQL Subscription Documents
 * 
 * Real-time subscription operations for the ix-studio frontend.
 * Reference: api/graphql/agent.graphql
 */

// ===== Construct Subscriptions =====

export const CONSTRUCT_CHANGED = `
  subscription ConstructChanged($constructId: ID!) {
    constructChanged(constructId: $constructId) {
      construct {
        id
        label
        state
        updatedAt
        graph {
          nodes {
            id
            type
            properties
            createdAt
            updatedAt
          }
          edges {
            id
            relation
            source
            target
            properties
            createdAt
          }
        }
      }
      changeType
      changedBy
      timestamp
    }
  }
`;

// ===== Promotion Subscriptions =====

export const MY_PROMOTION_EVENTS = `
  subscription MyPromotionEvents {
    myPromotionEvents {
      constructID
      state
      timestamp
      transactionID
      blockNumber
      rejectionReason
    }
  }
`;

// ===== Agent State Subscriptions =====

export const AGENT_STATE_CHANGED = `
  subscription AgentStateChanged($agentId: ID) {
    agentStateChanged(agentId: $agentId) {
      agent {
        id
        state
        lastActiveAt
      }
      previousState
      newState
      timestamp
    }
  }
`;

// ===== Task Subscriptions =====

export const MY_TASK_ASSIGNMENTS = `
  subscription MyTaskAssignments {
    myTaskAssignments {
      assignment {
        taskID
        payload
        assignedAt
      }
    }
  }
`;

// ===== Visible Scopes Subscriptions =====

export const VISIBLE_SCOPES_CHANGED = `
  subscription VisibleScopesChanged {
    visibleScopesChanged {
      scopes {
        scopeId
        displayName
        description
        icon
        affordanceDomains
        orderHint
        scopeStatus
      }
      timestamp
    }
  }
`;

// ===== Type Definitions for Subscription Payloads =====

export interface ConstructChangedPayload {
  constructChanged: {
    construct: {
      id: string;
      label: string | null;
      state: string;
      updatedAt: string;
      graph: {
        nodes: Array<{
          id: string;
          type: string;
          properties: Record<string, unknown>;
          createdAt: string;
          updatedAt: string;
        }>;
        edges: Array<{
          id: string;
          relation: string;
          source: string;
          target: string;
          properties: Record<string, unknown>;
          createdAt: string;
        }>;
      };
    };
    changeType: string;
    changedBy: string;
    timestamp: string;
  };
}

export interface PromotionEventPayload {
  myPromotionEvents: {
    constructID: string;
    state: 'DRAFT' | 'PENDING' | 'APPROVED' | 'REJECTED' | 'EXECUTED';
    timestamp: string;
    transactionID: string | null;
    blockNumber: number | null;
    rejectionReason: string | null;
  };
}

export interface AgentStateChangedPayload {
  agentStateChanged: {
    agent: {
      id: string;
      state: string;
      lastActiveAt: string;
    };
    previousState: string;
    newState: string;
    timestamp: string;
  };
}

export interface VisibleScopesChangedPayload {
  visibleScopesChanged: {
    scopes: Array<{
      scopeId: string;
      displayName: string;
      description: string | null;
      icon: string | null;
      affordanceDomains: string[];
      orderHint: number | null;
      scopeStatus: string;
    }>;
    timestamp: string;
  };
}
